<template>
  <div>
    <div id="content" class="login h-100" style="margin-top: -75px">
      <!-- Main Content -->
      <div class="main-content h-100">
        <div class="row h-100">
          <!-- Client -->
          <div class="col-12">
            <div class="card mb-0 h-100">
              <div class="card-header h-50">
                <img
                  class="icon-login"
                  src="../assets/images/icon-green.png"
                  alt="Icon"
                />
                <img
                  class="logo-login"
                  src="../assets/images/logo-green.png"
                  alt="Logo"
                />
              </div>
              <div class="card-body login-title">
                <div class="row" style="margin-top: -0px">
                  <div class="col-12">
                    <div
                      class="title"
                      style="text-align: center"
                      v-if="!demand_avaliated"
                    >
                      Avalie o serviço prestado por {{ demand.assignee.name }}
                      <br />
                      ID do Atendimento: #{{ demand.id }}
                    </div>
                    <div
                      class="title"
                      style="text-align: center"
                      v-if="demand_avaliated"
                    >
                      Obrigado por avaliar nosso atendimento!
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body" v-if="!demand_avaliated">
                <div class="row justify-content-center">
                  <div class="col-12">
                    <label
                      >Em uma escala de 0 a 10, que nota você daria ao
                      colaborador que lhe atendeu? (obrigatório)</label
                    >
                    <div class="rate">
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="sta10"
                        name="rate"
                        value="10"
                      />
                      <label for="sta10" title="text">10 </label>
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="star9"
                        name="rate"
                        value="9"
                      />
                      <label for="star9" title="text">9 </label>
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="star8"
                        name="rate"
                        value="8"
                      />
                      <label for="star8" title="text">8 </label>
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="star7"
                        name="rate"
                        value="7"
                      />
                      <label for="star7" title="text">7 </label>
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="star6"
                        name="rate"
                        value="6"
                      />
                      <label for="star6" title="text">6 </label>
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="star5"
                        name="rate"
                        value="5"
                      />
                      <label for="star5" title="text">5 </label>
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="star4"
                        name="rate"
                        value="4"
                      />
                      <label for="star4" title="text">4 </label>
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="star3"
                        name="rate"
                        value="3"
                      />
                      <label for="star3" title="text">3 </label>
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="star2"
                        name="rate"
                        value="2"
                      />
                      <label for="star2" title="text">2 </label>
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="star1"
                        name="rate"
                        value="1"
                      />
                      <label for="star1" title="text">1 </label>
                      <input
                        type="radio"
                        v-model="demand.customer_avaliation"
                        id="star0"
                        name="rate"
                        value="0"
                      />
                      <label for="star0" title="text">0 </label>
                    </div>
                  </div>
                  <div class="col-12">
                    <label>Observações (opcional):</label>
                    <textarea
                      v-model="demand.customer_observation"
                      class="form-control"
                      id=""
                      cols="30"
                      rows="7"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="card-footer" v-if="!demand_avaliated">
                <div class="row">
                  <div class="col-md-12">
                    <button class="btn btn-main mb-0" @click="save">
                      Salvar Avaliação
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      new_path: "/",
      demand: {
        customer_observation: "",
        customer_avaliation: "",
      },
    };
  },
  computed: {},
  methods: {
    save() {
      const self = this;
      const api = this.$store.state.api + "save-avaliation";

      axios
        .post(api, self.demand)
        .then((response) => {
          self.getEntity();
          self.$message("Sucesso", "Avaliação enviada com sucesso!", "success");
        })
        .catch((error) => {
          self.$message("Erro", "Não foi possivel salvar a avaliação", "error");
        });
    },
    getEntity() {
      const self = this;

      let hash = self.$route.params.hash;
      const api = this.$store.state.api + "get-avaliation/" + hash;

      axios
        .get(api)
        .then((response) => {
          self.demand = response.data;
          self.demand_avaliated = response.data.customer_avaliation;
        })
        .catch((error) => {
          self.$message(
            "Erro",
            "Não foi possivel coletar dados da avaliação",
            "error"
          );
        });
    },
  },
  components: {},
  props: {},
  mounted: function () {
    const self = this;
    self.getEntity();
  },
};
</script>
<style scoped>
.rate {
  /* float: center; */
  height: 56px;
  padding: 0;
}
.rate:not(:checked) > input {
  position: absolute;
  top: -9999px;
}
.rate:not(:checked) > label {
  float: right;
  width: 9%;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  padding: 5px;
  color: #777;
  border: 1px solid #555;
  text-align: center;
}
.rate:not(:checked) > label:before {
  content: "  ";
}
.rate > input:checked ~ label {
  color: #222;
  background-color: #2bd7d1;
}
.rate:not(:checked) > label:hover,
.rate:not(:checked) > label:hover ~ label {
  color: #222;
}
.rate > input:checked + label:hover,
.rate > input:checked + label:hover ~ label,
.rate > input:checked ~ label:hover,
.rate > input:checked ~ label:hover ~ label,
.rate > label:hover ~ input:checked ~ label {
  color: #222;
}
</style>


// WEBPACK FOOTER //
// src/components/AvaliationPublic.vue